<template>
  <canvas ref="chart" />
</template>

<script>
  import Chart from 'chart.js/auto'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import { mapGetters } from 'vuex'
  import { truncate } from '@js/str-utils'

  export default {
    name: 'PieChartPrimary',
    props: {
      chartType: { type: String, required: false, default: 'doughnut' },
      customTooltips: { type: Function, required: false, default: () => null },
      data: { type: Array, required: false, default: () => [] },
      dataLabelColor: { type: String, required: false, default: () => null },
      dataLabelFontSize: { type: Number, required: false, default: () => 12 },
      dataLabelFontWeight: { type: [String, Number], required: false, default: 'bold'},
      dataLabelDataPortionMin: { type: Number, required: false, default: 0.08 },
      dataLabelLengthMax: { type: Number, required: false, default: 16 },
      hoverOffset: { type: Number, required: false, default: 4 },
      label: { type: String, required: false, default: '' },
      labels: { type: Array, required: false, default: () => [] },
      showLegend: { type: Boolean, required: false, default: false },
      skipInitialUpdate: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        chart: null,
        ctx: null,
        options: {
          plugins: {
            legend: {
              display: false,
            },
            datalabels: {
              color: this.dataLabelColor,
              textAlign: 'center',
              font: {
                size: this.dataLabelFontSize,
                weight: this.dataLabelFontWeight,
              },
            }
          },
          maintainAspectRatio: false,
        },
        skipUpdate: this.skipInitialUpdate,
      };
    },
    created: function () {
      if (this.options.plugins.datalabels.color == null) {
        this.options.plugins.datalabels.color = this.color.dark2();
      }

      this.configureDataLabelFormatter();
    },
    mounted: async function () {
      await this.initializeCharts();
      await this.$watch('config', (newVal, oldVal) => {
        if (this.skipUpdate) {
          this.skipUpdate = false;
        } else {
          //The following scripts didn't work(datasets.backgroundColor
          //behaves strangely) therefore chart is destroyed and re-created
          //instead of simply updated by chart.update.
          //-----------------------------------------
          //this.chart.data.labels = this.labels;
          //this.chart.data.datasets = this.datasets;
          //this.chart.update();
          //-----------------------------------------
          this.configureDataLabelFormatter();
          this.chart.destroy();
          this.chart = new Chart(this.ctx, this.config);
        }
      }, { deep: true });
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      backgroundColor: function () {
        return [
          'rgb(235, 171, 173)', // red
          'rgb(242, 193, 179)', // orange
          'rgb(242, 232, 182)', // yellow
          'rgb(101, 238, 229)', // green
          'rgb( 99, 198, 238)', // blue
          'rgb(180, 140, 209)', // purple
          'rgb(212, 140, 193)', // violet
        ];
      },
      config: function () {
        return {
          type: this.chartType,
          data: {
            labels: this.labels,
            datasets: this.datasets,
          },
          options: this.options,
          plugins: [ChartDataLabels],
        };
      },
      datasets: function () {
        return [{
          data: this.data,
          backgroundColor: this.backgroundColor,
          hoverOffset: this.hoverOffset,
        }];
      },
    },
    methods: {
      configureDataLabelFormatter: function () {
        const total = this.data.length > 0 ? (
          this.data.reduce((result, elem) => result + elem, 0)) : 0;

        this.options.plugins.datalabels.formatter = (value, ctx) => {
          const isTooSmallPortion = (value / total) <= this.dataLabelDataPortionMin;
          return isTooSmallPortion ? '' : truncate(
              ctx.chart.data.labels[ctx.dataIndex], this.dataLabelLengthMax);
        };
      },
      initializeCharts: function () {
        this.ctx = this.$refs.chart;
        this.chart = new Chart(this.ctx, this.config);
      },
    },
  };
</script>
